import { getSourceComponentsPlugin } from './get-source-components-plugin';
import { getComponentMetadataForEditing } from './get-component-metadata-for-editing';
import { getPreviewComponents, getPreviewCardGroups } from './get-preview-components';
import { BUTTON_LIBRARY_STYLESHEET } from './base-components/display/components/r-button/button-library-stylesheet';
import { ACCORDION_LIBRARY_STYLESHEET } from './base-components/display/components/r-accordion/accordion-library-stylesheet';
import packageJson from '../package.json';

/**
 * ComponentLibraryModule conformance (the @rulecms/widget-react contract).
 *
 * This package is the DEFAULT component library. It conforms to the contract
 * STRUCTURALLY — it has no dependency on @rulecms/widget-react (the
 * devDependency-only type-conformance test in
 * __tests__/contract-conformance.test.ts guarantees the shape). Consumers
 * register it, e.g.:
 *
 *   libraries: { default: () => import('@rulecms/source-components-react') }
 *
 * or statically import the module for SSR pages.
 */

export const manifest = {
  id: 'default',
  version: packageJson.version,
  reactPeerRange: '>=16.8.0',
};

/** The render surface: component type → renderable entry. */
export const components = getSourceComponentsPlugin().components;

/**
 * Optional `ComponentLibraryModule.stylesheet`. widget-react injects this
 * once per library as an SSR `<style>` tag. Button hover / focus / active
 * plus accordion open/close motion and the custom chevron.
 */
export const stylesheet = `${BUTTON_LIBRARY_STYLESHEET}\n${ACCORDION_LIBRARY_STYLESHEET}`;

/** The editor surface: palette + attribute metadata for the RuleCMS composer. */
export const editor = {
  previewComponents: getPreviewComponents(),
  previewCardGroups: getPreviewCardGroups(),
  componentMetadata: getComponentMetadataForEditing(),
};
